// Perplexity's SSE-parsing bug currently returns null query/answer, so this is
// an illustrative placeholder (real response shape, real "turbo" model value)
// rather than a captured response. Swap in a real one once the parser is fixed.
const answer = `The largest known star in the universe by radius is Stephenson 2-18, a red hypergiant with an estimated radius of around 2,150 times that of our Sun. UY Scuti, once considered the largest, is now estimated at roughly 1,700 times the Sun's radius, though some newer measurements suggest a smaller figure closer to 900-1,100 solar radii.

Both stars are red supergiants/hypergiants nearing the end of their lives, and their exact size is difficult to pin down since stars don't have solid surfaces.`;

const response = {
  query: "What is the largest sun in the universe?",
  url: "https://www.perplexity.ai/search/8b035595-2bb1-4ea7-9e3b-39b14aae3648",
  model: "turbo",
  answer,
  sources: [
    {
      title: "UY Scuti - Wikipedia",
      url: "https://en.wikipedia.org/wiki/UY_Scuti",
      domain: "en.wikipedia.org",
      snippet: "UY Scuti is a red supergiant or hypergiant star, one of the largest known stars by radius."
    },
    {
      title: "What is the biggest star in the universe? - Space",
      url: "https://www.space.com/41290-biggest-star.html",
      domain: "space.com",
      snippet: "The biggest known star is UY Scuti, about 1,700 times larger than the sun."
    }
  ],
  related_queries: []
};

export const async_perplexity = {
  input: "What is the largest sun in the universe?",
  result: JSON.stringify(response, null, 2)
};
